import Default from "./Default";
import ChoosedArea from "./ChoosedArea";

export default {
    Default,
    ChoosedArea
}